import { app } from '../../../app';
import { Controller } from './hard-token-management.controller';

app.component('companyHardTokenManagement', {
    bindings: {
        companyId: '<',
        hardTokens: '<',
    },
    controller: Controller,
    templateUrl: require('./hard-token-management.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-management.component.js